module.exports = __webpack_public_path__ + "img/EE11971924.0474f099.png";